import React from "react";

const ClientSay = () => {
  return (
    <section
      className="ds s-pt-55 s-pb-10 s-pt-lg-90 s-pb-lg-60 s-parallax testimonials-section"
      id="section_testimonials"
    >
      <div className="container">
        <div className="row">
          <div class=" col-12 mb-60 text-center">
            <h4>What our clients says</h4>
            <h5>More Google Reviews</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div
              class="embedsocial-reviews"
              data-ref="0fca228699d33ce3c8ed89e1ee8ddf312312a160"
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientSay;
